<template>
  <div class="progressBarBox">
    <div class="progressBar">
      <div class="currentProgress" :class="{ type2: isTljGone }">
        {{ isTljGone ? "即将抢光": "正在热抢" }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isTljGone: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.progressBarBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: vw(8);
  .progressBar {
    position: relative;
    width: 100%;
    height: vw(16);
    background: #fdebe7;
    border-radius: vw(8);
    .currentProgress {
      display: flex;
      align-items: center;
      width: 70%;
      height: vw(16);
      line-height: vw(16);
      background: linear-gradient(90deg, #f23030 3%, #ff5f5f);
      border-radius: vw(9);
      font-size: vw(10);
      color: #fff;
      padding-left: vw(6);
      box-sizing: border-box;
      &.type2 {
        width: 100%;
      }
    }
  }
}
</style>
